<template>
  <div>
     <five-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj="titleObj"
    >
    </five-header>
    <div v-html="freeData"></div>
    <five-footer :bottom="bottom" :bottomInfo="bottomInfo"></five-footer>

  </div>
</template>

<script>
import FiveHeader from "@/components/mobile/Header";
import FiveFooter from "@/components/mobile/Footer";
export default {
  data() {
    return {
      freeData: "",
      topStyle: "",
      actIndex: 2,
      noLine: true,
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      about: {},
      culture: {},
      developList: [],
      teamList: [],
      partner: [],
       titleObj: {
        title: "免单节营销解决方案",
        desc:
          "狂欢免单，创造属于自己的城市营销解决方案",
      },
    };
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.getFreeData();
  },
    components: {
    FiveHeader,
    FiveFooter,
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_freeMarket");
      } else {
        this.$router.push("/freeMarket");
      }
    },
    getFreeData() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/productdetail",
        { id: 4 },
        (res) => {
          if (res.code == 1) {
            this.freeData = res.data.content;
          }
        }
      );
    },
     getPageData() {
      this.$http.post("home/index/m_aboutpag", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;

        this.topStyle =
          "background-image:url('" +
          require("../../static/images/fiveG/m_bg.png") +
          "')";

        this.about = res.data.company[0];
        this.culture = res.data.culture[0];
        this.developList = res.data.develop;
        this.teamList = res.data.team;
        this.partner = res.data.partner;
        this.bottomInfo = res.data.contact[0];
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/mobile/freeMarket.vue